import { useMemo } from 'react';

import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useGetVenues } from 'src/hooks/api/useVenuesEndpoint';
import { PrimaryTag } from 'src/pages/People/Edit/components/Information/components/MobileLists.styled';
import { LOCAL_STORAGE_KEYS } from 'src/utils/constants/localStorageConstants';
import useLocalStorage from 'use-local-storage';

interface DrawerSelectOption {
  value: string;
  label: string | React.ReactNode;
  disabled?: boolean;
}

export const useMakeDefault = (
  localStorageKey: 'access_logs_default_venue' | 'payment_logs_default_venue' | 'ticket_logs_default_venue' | undefined,
  activeItem: string | undefined,
) => {
  const { t } = useTranslation();
  const [defaultItem, setDefaultItem] = useLocalStorage<DrawerSelectOption | null>(
    localStorageKey ? LOCAL_STORAGE_KEYS[localStorageKey] : 'access_logs_default_venue',
    null,
  );
  const { data: venues } = useGetVenues();

  const venuesToSelectMapped = useMemo(
    () =>
      venues?.map((venue) => ({
        value: venue.id || '',
        label: venue.name || '',
      })),
    [venues],
  );

  const handleMakeDefault = (e: React.MouseEvent<HTMLElement, MouseEvent>, selectedItem?: string) => {
    e.stopPropagation();

    if (selectedItem === defaultItem?.value) {
      setDefaultItem(null);
      return;
    }
    const nextDefault = venuesToSelectMapped?.find((venue) => venue.value === selectedItem);

    setDefaultItem(nextDefault);
  };

  const makeDefault = (item: DrawerSelectOption) => {
    if (activeItem === item.value && defaultItem?.value === item.value) {
      return (
        <Button onClick={(e) => handleMakeDefault(e, `${item.value}`)} type="text">
          {t('interactions.clear')}
        </Button>
      );
    }

    if (item.value === defaultItem?.value) {
      return <PrimaryTag>{t('interactions.default')}</PrimaryTag>;
    }

    return (
      <Button onClick={(e) => handleMakeDefault(e, `${item.value}`)} type="text">
        {t('interactions.makeDefault')}
      </Button>
    );
  };

  return {
    defaultItem,
    makeDefault,
  };
};
